import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74a42b3a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=74a42b3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a42b3a",
  null
  
)

export default component.exports